import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="check_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M883.499 225.835a42.667 42.667 0 0 1 0 60.33L414.165 755.5a42.667 42.667 0 0 1-60.33 0L140.5 542.165a42.667 42.667 0 1 1 60.331-60.33L384 665.003l439.168-439.168a42.667 42.667 0 0 1 60.33 0z"
    />
  </svg>
);
export default SvgCheckIcon;
